const normalizeMut = arr=>{
  var total = 0;
  for(i in arr)total+=arr[i];
  for(i in arr)arr[i]=arr[i]/total;
  return arr;
}
const normalize = arr=>{
  let [min,max] = ['min','max'].map(x=>Math[x].apply(null,arr));
  for(i in arr)arr[i]=(arr[i]-min)/(max-min);
  return arr;
}
module.exports = function(cy){cy('collection', 'eigenRank', function({
  weight=()=>1,iterations=200,precision=0.000001}={}){
  let cy = this._private.cy;
  let { nodes, edges } = this.byGroup();
  let numNodes = nodes.length;
  let numNodesSqd = numNodes * numNodes;
  let _matOrd = (s,t)=>+t+s*numNodes;

  // Construct matrix with wins and losses with each row as team and
  // score 2(if won) or 1 (if drawn) against the column as opponent team
  // We'll also keep track of the sum of each row
  let matrix = Array(numNodesSqd).fill(0);
  let eigenvector = Array(numNodes).fill(0);
  // Now, process edges
  for(let edge of edges){
    let srcId = edge.data('source');
    let tgtId = edge.data('target');

    // Don't include loops in the matrix
    if( srcId === tgtId )continue;

    let s = nodes.indexOfId( srcId );
    let t = nodes.indexOfId( tgtId );
    let w = weight( edge );

    matrix[_matOrd(s,t)] += w;
    eigenvector[t] += w;
    //console.log({s,t,n})
  }
  // Compute dominant eigenvector using power method
  normalizeMut(eigenvector);
  for( let iter = 0; iter < iterations; iter++ ){
    let next = Array(numNodes).fill(0);
    // Multiply matrix with previous result
    for(let s in eigenvector)for(let t in eigenvector)
      next[t] += matrix[_matOrd(s,t)] * eigenvector[s];
    if(next.every(x=>!x))break;
    normalizeMut( next );
    let diff = 0;
    // Compute difference (squared module) of both vectors
    for( let i  in eigenvector ){
      let delta = next[i] - eigenvector[i];
      diff += delta * delta;
    }
    if(diff<precision)break;
    eigenvector = next;
  }
  normalize(eigenvector);
  return { rank: function( node ){
    node = cy.collection(node)[0];
    return eigenvector[ nodes.indexOf(node) ];
  }};
})}
